const dev = process.env.NODE_ENV === "development";
export const logError = (...args) => { if (dev) console.error(...args); };
export const logWarn = (...args) => { if (dev) console.warn(...args); };
